import React from 'react';
import { SearchIcon, MessageSquareIcon } from 'lucide-react';
const SPACES = ['Engineering', 'Sales', 'Product'];
const CHATS = [{
  title: 'API migration plan',
  time: '2 hours ago',
  space: 'Engineering',
  channel: 'Web'
}, {
  title: 'Q2 sales strategy',
  time: '4 hours ago',
  space: 'Sales',
  channel: 'Slack'
}, {
  title: 'New onboarding flow review',
  time: 'Yesterday',
  space: 'Product',
  channel: 'Web'
}, {
  title: 'Brand refresh brainstorm',
  time: 'Yesterday',
  space: 'Design',
  channel: 'Slack'
}, {
  title: 'Campaign performance debrief',
  time: '2 days ago',
  space: 'Marketing',
  channel: 'Web'
}];
export function ChatManagement() {
  return <div className="w-full max-w-[800px] mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-neutral-200" data-id="element-35">
      <div className="px-6 py-5" data-id="element-36">
        {/* Header row: title + space filters */}
        <div className="flex items-center justify-between mb-4" data-id="element-37">
          <h2 className="text-xl font-bold text-[#2A1B22]" data-id="element-38">Chats</h2>
          <div className="flex items-center gap-2" data-id="element-39">
            {SPACES.map((space, idx) => <span key={space} className={`px-2.5 py-1 rounded-md text-sm font-medium border ${idx === 0 ? 'bg-[#2A1B22] text-white border-[#2A1B22]' : 'bg-neutral-50 text-neutral-500 border-neutral-200'}`} data-id="element-40">
                {space}
              </span>)}
            <span className="text-neutral-400 text-sm font-medium px-1" data-id="element-41">…</span>
          </div>
        </div>

        {/* Search */}
        <div className="relative mb-4" data-id="element-42">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" data-id="element-43" />
          <div className="w-full pl-9 pr-4 py-2 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-400 text-sm" data-id="element-44">
            Search chats...
          </div>
        </div>

        {/* Filter row: visibility left, channel right */}
        <div className="flex items-center justify-between mb-4" data-id="element-45">
          <div className="flex items-center gap-2" data-id="element-46">
            <span className="px-2.5 py-1 rounded-md text-sm font-medium border bg-[#2A1B22] text-white border-[#2A1B22]" data-id="element-47">
              My Chats
            </span>
            <span className="px-2.5 py-1 rounded-md text-sm font-medium border bg-neutral-50 text-neutral-500 border-neutral-200" data-id="element-48">
              Shared Chats
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-49">
            <span className="px-2.5 py-1 rounded-md text-sm font-medium border bg-blue-50 text-blue-600 border-blue-200" data-id="element-50">
              Web
            </span>
            <span className="px-2.5 py-1 rounded-md text-sm font-medium border bg-neutral-50 text-neutral-500 border-neutral-200" data-id="element-51">
              Slack
            </span>
          </div>
        </div>

        {/* Chat list */}
        <div className="flex flex-col divide-y divide-neutral-100" data-id="element-52">
          {CHATS.map((chat, idx) => <div key={idx} className="flex items-center justify-between py-3 gap-4" data-id="element-53">
              <div className="flex items-center gap-3 min-w-0" data-id="element-54">
                <div className="w-8 h-8 rounded-lg bg-neutral-100 border border-neutral-200 flex items-center justify-center shrink-0" data-id="element-55">
                  <MessageSquareIcon className="w-4 h-4 text-neutral-400" data-id="element-56" />
                </div>
                <div className="min-w-0" data-id="element-57">
                  <p className="text-sm font-medium text-[#0f172a] truncate" data-id="element-58">
                    {chat.title}
                  </p>
                  <p className="text-xs text-neutral-400" data-id="element-59">{chat.time}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0" data-id="element-60">
                <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-neutral-100 text-neutral-500 border border-neutral-200" data-id="element-61">
                  {chat.space}
                </span>
                <span className={`px-2 py-0.5 rounded-md text-xs font-medium border ${chat.channel === 'Slack' ? 'bg-purple-50 text-purple-500 border-purple-200' : 'bg-blue-50 text-blue-500 border-blue-200'}`} data-id="element-62">
                  {chat.channel}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}